import { render, staticRenderFns } from "./inventory-packages-form.vue?vue&type=template&id=6c3a3b4b"
import script from "./inventory-packages-form.vue?vue&type=script&lang=js"
export * from "./inventory-packages-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports